import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/18c6998c39bb0c6800adc881f1fbc8c0/b69dc01a38e55ca7dddfd05b194eb92a.jpeg" 
              alt="BigBen PLLC" 
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Big Ben Injury Law PLLC is a premier personal injury law firm serving clients across Florida and New Jersey. 
              We fight tirelessly to secure maximum compensation for our clients.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li><a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Practice Areas</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#results" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Results</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Blog</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">FAQ</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact Info</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-phone-line text-cyan-400 mt-1 mr-3"></i>
                <div>
                  <div className="font-semibold">24/7 Hotline</div>
                  <div className="text-gray-300">(561) 765-2540</div>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-mail-line text-cyan-400 mt-1 mr-3"></i>
                <div>
                  <div className="font-semibold">Email</div>
                  <div className="text-gray-300">Office@Bigbeninjurylaw.com</div>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-map-pin-line text-cyan-400 mt-1 mr-3"></i>
                <div>
                  <div className="font-semibold">Offices</div>
                  <div className="text-gray-300">Florida & New Jersey</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Big Ben Injury Law PLLC. All rights reserved. | 
              <Link to="/privacy-policy" className="hover:text-white ml-2 cursor-pointer">Privacy Policy</Link> | 
              <a href="#" className="hover:text-white ml-2 cursor-pointer">Terms of Service</a>
            </div>
            <div className="text-gray-400 text-sm">
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
          
          <div className="mt-6 text-xs text-gray-500 leading-relaxed">
            <p>
              <strong>Disclaimer:</strong> The information on this website is for general information purposes only. 
              Nothing on this site should be taken as legal advice for any individual case or situation. 
              This information is not intended to create, and receipt or viewing does not constitute, 
              an attorney-client relationship. Past results do not guarantee future outcomes.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
